import { get, patch, post, type RequestOptions } from '@/api/client';
import type { SmsConversationAction, SmsInboxResponse, SmsThread } from './types';

export const messagesApi = {
  getInbox: (
    params?: { status?: string; awaiting_response?: boolean },
    options?: RequestOptions,
  ) =>
    get<SmsInboxResponse>(
      '/api/messages/sms',
      {
        ...(params?.status ? { status: params.status } : {}),
        ...(params?.awaiting_response ? { awaiting_response: 'true' } : {}),
      },
      options,
    ),

  getThread: (conversationId: string, topic?: string, options?: RequestOptions) =>
    get<SmsThread>(`/api/messages/sms/${conversationId}`, topic ? { topic } : {}, options),

  patchConversation: (conversationId: string, action: SmsConversationAction) =>
    patch<void>(`/api/messages/sms/${conversationId}`, { action }),

  sendReply: (conversationId: string, body: string) =>
    post<void>(`/api/messages/sms/${conversationId}/reply`, { body }),

  sendOutbound: (payload: { body: string; to_phone: string; patient_id?: number }) =>
    post<{ id?: string; conversation_id?: string }>('/api/messages/sms', payload),

  escalate: (conversationId: string) =>
    post<void>(`/api/messages/sms/${conversationId}/escalate`),

  generateEpisodeSummary: (episodeId: number) =>
    post<{ status: string; episode_id: number }>(`/api/messages/episodes/${episodeId}/summary`),
};
